import { render, staticRenderFns } from "./DeliveryComponent.vue?vue&type=template&id=161a4ffe"
import script from "./DeliveryComponent.vue?vue&type=script&lang=js"
export * from "./DeliveryComponent.vue?vue&type=script&lang=js"
import style0 from "./DeliveryComponent.vue?vue&type=style&index=0&id=161a4ffe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports